import { render, staticRenderFns } from "./LegalDocumentFormFiles.vue?vue&type=template&id=1709327a&scoped=true&"
import script from "./LegalDocumentFormFiles.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentFormFiles.vue?vue&type=style&index=0&id=1709327a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1709327a",
  null
  
)

export default component.exports